import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";

const services = [
  { label: "Mutual Funds", href: "/mutual-funds" },
  { label: "Insurance", href: "/insurance" },
  { label: "FDs & Bonds", href: "/fd-bonds" },
  { label: "PMS & SIF", href: "/pms-sif" },
];

const quickLinks = [
  { label: "Calculators", href: "/calculators" },
  { label: "Child Education", href: "/children-education" },
  { label: "MF Returns", href: "/mutual-fund-returns" },
  { label: "Blog", href: "/blog" },
  { label: "Partners", href: "/partners" },
  { label: "StethoWealth", href: "/stethowealth" },
  { label: "Careers", href: "/careers" },
  { label: "Contact Us", href: "/contact" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms", href: "/terms" },
  { label: "Disclaimer", href: "/disclaimer" },
  { label: "Commission Disclosure", href: "/commission-disclosure" },
  { label: "Grievance Redressal", href: "/grievance-redressal" },
  { label: "Important Links", href: "/important-links" },
];

const socials = [
  { icon: <Facebook size={15} />, href: "#", label: "Facebook" },
  { icon: <Twitter size={15} />, href: "#", label: "Twitter" },
  { icon: <Linkedin size={15} />, href: "#", label: "LinkedIn" },
  { icon: <Instagram size={15} />, href: "#", label: "Instagram" },
];

export default function Footer() {
  return (
    <footer style={{ background: "#1e1f52", color: "rgba(255,255,255,0.8)" }}>
      {/* Top CTA strip — mobile only */}
      <div className="footer-cta-strip">
        <a href="tel:+916280307033" className="footer-cta-link">
          <Phone size={14} style={{ color: "var(--green)" }} />
          +91 62803 07033
        </a>
        <span className="footer-cta-sep" />
        <a href="mailto:Care@finadore.com" className="footer-cta-link">
          <Mail size={14} style={{ color: "var(--green)" }} />
          Care@finadore.com
        </a>
      </div>

      <div className="container" style={{ padding: "48px 20px 24px" }}>
        {/* Main grid */}
        <div className="footer-main-grid">
          {/* Brand column */}
          <div className="footer-brand">
            <div style={{ display: "inline-block", background: "white", borderRadius: 10, padding: "8px 14px", marginBottom: 16 }}>
              <img
                src="/logo-new.png"
                alt="Finadore"
                style={{ height: 38, width: "auto", objectFit: "contain", maxWidth: 170, display: "block" }}
              />
            </div>
            <p style={{ fontSize: 13.5, lineHeight: 1.7, maxWidth: 280, marginBottom: 18, fontFamily: "DM Sans, sans-serif", color: "rgba(255,255,255,0.6)" }}>
              Your trusted partner for Mutual Funds, Insurance, FDs, Bonds & more. AMFI Registered Mutual Fund Distributor ARN-300809 · APMI Registered PMS Distributor APRN-06724.
            </p>

            {/* Social icons */}
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  style={{ width: 34, height: 34, borderRadius: 8, background: "rgba(255,255,255,0.07)", display: "flex", alignItems: "center", justifyContent: "center", color: "white", textDecoration: "none", transition: "background 0.2s, transform 0.2s", border: "1px solid rgba(255,255,255,0.07)" }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(16,185,129,0.35)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.transform = "translateY(0)"; }}
                >
                  {s.icon}
                </a>
              ))}
            </div>

            {/* App badges */}
            <p style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", fontFamily: "DM Sans, sans-serif", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.5px" }}>Download App</p>
            <div style={{ display: "flex", gap: 10 }}>
              <a href="https://apps.apple.com/gb/app/finadore/id6615080710" target="_blank" rel="noopener noreferrer"
                title="Download on the App Store"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.09)", border: "1px solid rgba(255,255,255,0.14)", textDecoration: "none", transition: "background 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.18)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.09)"}>
                <svg width="20" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.finadore.finadore" target="_blank" rel="noopener noreferrer"
                title="Get it on Google Play"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.09)", border: "1px solid rgba(255,255,255,0.14)", textDecoration: "none", transition: "background 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.18)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.09)"}>
                <svg width="20" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M2.05 1.38C2.02 1.49 2 1.6 2 1.72v20.56c0 .12.02.23.05.33L13.04 12 2.05 1.38z" fill="#4285F4" />
                  <path d="M3.18 23.76c.3.17.65.19.99.08l12.49-7.2-2.76-2.76-10.72 9.88z" fill="#34A853" />
                  <path d="M20.52 10.3l-2.54-1.46-3.14 3.14 3.14 3.14 2.55-1.47c.73-.42.73-1.53-.01-1.95z" fill="#FBBC04" />
                  <path d="M4.17.16C3.83.05 3.48.07 3.18.24L13.04 10.1l2.76-2.76L4.17.16z" fill="#EA4335" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links — Services */}
          <div className="footer-col">
            <h4 className="footer-col-heading">Services</h4>
            {services.map(s => (
              <Link key={s.label} to={s.href} className="footer-link"
                onMouseEnter={e => e.currentTarget.style.color = "var(--green)"}
                onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.55)"}>
                {s.label}
              </Link>
            ))}
          </div>

          {/* Links — Quick */}
          <div className="footer-col">
            <h4 className="footer-col-heading">Quick Links</h4>
            {quickLinks.map(l => (
              <Link key={l.href} to={l.href} className="footer-link"
                onMouseEnter={e => e.currentTarget.style.color = "var(--green)"}
                onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.55)"}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div className="footer-col footer-contact-col">
            <h4 className="footer-col-heading">Contact</h4>
            <div className="footer-contact-items">
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <MapPin size={14} style={{ color: "var(--green)", flexShrink: 0, marginTop: 3 }} />
                <span style={{ fontSize: 13.5, fontFamily: "DM Sans, sans-serif", lineHeight: 1.55, color: "rgba(255,255,255,0.6)" }}>
                  Regus Jalandhar &amp; WeWork Gurgaon
                </span>
              </div>
              <a href="tel:+916280307033" className="footer-contact-link">
                <Phone size={14} style={{ color: "var(--green)", flexShrink: 0 }} />
                +91 62803 07033
              </a>
              <a href="mailto:Care@finadore.com" className="footer-contact-link">
                <Mail size={14} style={{ color: "var(--green)", flexShrink: 0 }} />
                Care@finadore.com
              </a>
            </div>
          </div>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.07)", margin: "32px 0 20px" }} />

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p style={{ fontSize: 12, fontFamily: "DM Sans, sans-serif", margin: 0, color: "rgba(255,255,255,0.35)", lineHeight: 1.7 }}>
            © 2025 Finadore. AMFI Registered Mutual Fund Distributor ARN-300809 · APMI Registered PMS Distributor APRN-06724.<br className="footer-break" />
            Mutual Fund investments are subject to market risks.
          </p>
          <div className="footer-legal-links">
            {legalLinks.map(t => (
              <Link key={t.label} to={t.href} style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", textDecoration: "none", fontFamily: "DM Sans, sans-serif", whiteSpace: "nowrap", transition: "color 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}
                onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.35)"}>
                {t.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        /* --- Footer Mobile Styles --- */

        /* CTA strip: hidden on desktop, shown on mobile */
        .footer-cta-strip {
          display: none;
          align-items: center;
          justify-content: center;
          gap: 0;
          background: rgba(16,185,129,0.18);
          border-bottom: 1px solid rgba(255,255,255,0.06);
          padding: 12px 20px;
          flex-wrap: wrap;
        }
        .footer-cta-link {
          display: flex;
          align-items: center;
          gap: 7px;
          color: rgba(255,255,255,0.8);
          text-decoration: none;
          font-size: 13px;
          font-family: DM Sans, sans-serif;
          font-weight: 600;
          padding: 4px 10px;
        }
        .footer-cta-sep {
          width: 1px;
          height: 16px;
          background: rgba(255,255,255,0.15);
        }

        /* Main grid: 4 cols → 2 cols → 1 col */
        .footer-main-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 40px;
          margin-bottom: 0;
        }

        .footer-col-heading {
          color: rgba(255,255,255,0.9);
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 14px;
          margin-top: 0;
          font-family: DM Sans, sans-serif;
          letter-spacing: 0.7px;
          text-transform: uppercase;
        }
        .footer-link {
          display: block;
          font-size: 13.5px;
          color: rgba(255,255,255,0.55);
          text-decoration: none;
          margin-bottom: 8px;
          font-family: DM Sans, sans-serif;
          transition: color 0.15s;
        }
        .footer-contact-items {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .footer-contact-link {
          display: flex;
          align-items: center;
          gap: 10px;
          color: rgba(255,255,255,0.65);
          text-decoration: none;
          font-size: 13.5px;
          font-family: DM Sans, sans-serif;
          transition: color 0.15s;
        }
        .footer-contact-link:hover { color: white; }

        /* Bottom bar */
        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }
        .footer-legal-links {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }
        .footer-break { display: none; }

        /* === TABLET (≤900px) === */
        @media (max-width: 900px) {
          .footer-main-grid {
            grid-template-columns: 1.6fr 1fr 1fr;
            gap: 28px;
          }
          .footer-contact-col {
            grid-column: 1 / -1;
          }
        }

        /* === MOBILE (≤640px) === */
        @media (max-width: 640px) {
          .footer-cta-strip { display: flex; }

          .footer-main-grid {
            grid-template-columns: 1fr 1fr;
            gap: 24px 16px;
          }

          /* Brand: full width, centered */
          .footer-brand {
            grid-column: 1 / -1;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid rgba(255,255,255,0.07);
          }
          .footer-brand p { max-width: 100% !important; }
          .footer-brand > div:first-child { display: flex; justify-content: center; }

          /* Services + Quick Links: 2 columns side by side */
          .footer-col { }

          /* Contact: full width on mobile, hidden since we have CTA strip */
          .footer-contact-col {
            grid-column: 1 / -1;
            background: rgba(255,255,255,0.03);
            border-radius: 12px;
            padding: 16px;
            border: 1px solid rgba(255,255,255,0.06);
          }

          /* Bottom bar: stacked */
          .footer-bottom {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }
          .footer-legal-links {
            gap: 10px 14px;
          }
          .footer-break { display: inline; }
        }

        /* === SMALL MOBILE (≤380px) === */
        @media (max-width: 380px) {
          .footer-main-grid {
            grid-template-columns: 1fr;
          }
          .footer-brand {
            align-items: flex-start;
            text-align: left;
          }
          .footer-legal-links {
            flex-direction: column;
            gap: 8px;
          }
        }
      `}</style>
    </footer>
  );
}
